import { render, staticRenderFns } from "./_footerEcommerce.vue?vue&type=template&id=0f61232a&"
import script from "./_footerEcommerce.vue?vue&type=script&lang=js&"
export * from "./_footerEcommerce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports